import './ModuleCompletionVariants.css';

export const LeafCompletionIllustration = () => (
  <svg viewBox="0 0 320 156" focusable="false" role="presentation">
    <ellipse cx="160" cy="134" rx="47" ry="6" fill="#e6ded2" opacity=".6" />
    <circle className="module-leaf__halo" cx="172" cy="61" r="35" />
    <path className="module-leaf__stem" d="M159 130 C154 106 169 79 174 48" pathLength="1" />
    <g className="module-leaf__lower-leaf">
      <path d="M159 109 C131 114 112 99 112 78 C136 74 157 84 159 109Z" fill="#9ba98d" />
      <path d="M159 109 Q137 91 122 86" fill="none" stroke="#788b6b" strokeWidth="1.8" strokeLinecap="round" />
    </g>
    <g className="module-leaf__upper-leaf">
      <path d="M168 81 C166 54 185 35 212 34 C215 60 197 82 168 81Z" fill="#9ba98d" />
      <path d="M168 81 Q187 58 201 45" fill="none" stroke="#788b6b" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M185 62 186 50 M188 59 201 58" fill="none" stroke="#788b6b" strokeWidth="1.3" strokeLinecap="round" opacity=".6" />
    </g>
    <g className="module-leaf__bud">
      <path d="M174 49 C154 44 150 28 159 15 C175 20 183 34 174 49Z" fill="#a9afc5" />
      <path d="M174 49 Q168 32 160 23" fill="none" stroke="#9098b3" strokeWidth="1.5" strokeLinecap="round" />
    </g>
    <g className="module-leaf__spark" fill="none" stroke="var(--foundation-orange-500, #ee964b)" strokeWidth="2" strokeLinecap="round">
      <path d="M226 56v7 M222.5 59.5h7 M128 46v5 M125.5 48.5h5" />
      <circle cx="214" cy="94" r="2" fill="var(--foundation-orange-500, #ee964b)" stroke="none" />
    </g>
    <path d="M107 130 Q106 122 102 119 M107 130 Q112 123 117 124 M207 129 Q207 122 211 119" fill="none" stroke="#a9afc5" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const BookCompletionIllustration = () => (
  <svg viewBox="0 0 320 156" focusable="false" role="presentation">
    <ellipse cx="160" cy="132" rx="91" ry="7" fill="#e6ded2" opacity=".55" />
    <circle className="module-book__halo" cx="204" cy="69" r="45" />
    <path d="M73 49 Q116 36 159 56 Q203 36 247 49 L249 124 Q201 112 160 134 Q118 113 71 124Z" fill="#9ba98d" />
    <path d="M78 45 Q120 35 160 54 L160 127 Q119 108 78 118Z" fill="#e8e9e2" />
    <path d="M160 54 Q201 35 242 45 L242 118 Q201 108 160 127Z" fill="#e8e9e2" />
    <path d="M80 38 Q121 30 160 51 L160 121 Q121 101 80 111Z" fill="#faf7f0" stroke="#e6ded2" strokeWidth="1" strokeLinejoin="round" />
    <path d="M160 51 Q200 30 240 38 L240 111 Q200 101 160 121Z" fill="#fffdf8" stroke="#e6ded2" strokeWidth="1" strokeLinejoin="round" />
    <path d="M95 58 Q116 55 143 65 M95 72 Q116 69 141 78 M95 86 Q114 84 131 89" fill="none" stroke="#a9afc5" strokeWidth="3" strokeLinecap="round" opacity=".6" />
    <path d="M160 53v68" fill="none" stroke="#d9d1c4" strokeWidth="1.5" />
    <path d="M130 113v18l6-4 6 8v-18" fill="#a9afc5" />
    <g className="module-book__badge">
      <circle cx="204" cy="77" r="19" fill="var(--foundation-orange-500, #ee964b)" />
      <path className="module-book__check" d="m195 77 6 6 12-13" pathLength="1" />
    </g>
    <g className="module-book__turning-page">
      <path d="M160 51 Q200 30 240 38 L240 111 Q200 101 160 121Z" fill="#f1ede3" stroke="#ded6c7" strokeWidth="1" strokeLinejoin="round" />
      <path d="M178 62 Q201 52 224 54 M178 76 Q201 66 224 68 M178 90 Q193 84 210 83" fill="none" stroke="#a9afc5" strokeWidth="3" strokeLinecap="round" opacity=".55" />
    </g>
    <g className="module-book__spark" fill="none" stroke="var(--foundation-orange-500, #ee964b)" strokeWidth="2" strokeLinecap="round">
      <path d="M257 67v8 M253 71h8 M206 16v6 M203 19h6" />
    </g>
  </svg>
);

export const ConstellationCompletionIllustration = () => (
  <svg viewBox="0 0 320 156" focusable="false" role="presentation">
    <path d="M44 107 C71 25 204-1 277 67" fill="none" stroke="#e6ded2" strokeWidth="1.5" strokeLinecap="round" strokeDasharray="2 8" />
    <circle className="module-stars__halo" cx="245" cy="45" r="29" />
    <path className="module-stars__connection" d="m65 109 52-48 47 42 40-64 41 6" pathLength="1" />
    <g className="module-stars__point module-stars__point--first">
      <circle cx="65" cy="109" r="13" fill="#9ba98d" opacity=".12" />
      <circle cx="65" cy="109" r="6" fill="#9ba98d" />
    </g>
    <g className="module-stars__point module-stars__point--second">
      <circle cx="117" cy="61" r="15" fill="#a9afc5" opacity=".13" />
      <circle cx="117" cy="61" r="7" fill="#a9afc5" />
    </g>
    <g className="module-stars__point module-stars__point--third">
      <circle cx="164" cy="103" r="13" fill="#9ba98d" opacity=".12" />
      <circle cx="164" cy="103" r="6" fill="#9ba98d" />
    </g>
    <g className="module-stars__point module-stars__point--fourth">
      <circle cx="204" cy="39" r="12" fill="#a9afc5" opacity=".13" />
      <circle cx="204" cy="39" r="5.5" fill="#a9afc5" />
    </g>
    <g className="module-stars__final">
      <path d="M245 29 Q248 42 261 45 Q248 48 245 61 Q242 48 229 45 Q242 42 245 29Z" fill="var(--foundation-orange-500, #ee964b)" />
      <circle cx="245" cy="45" r="3" fill="#fffdf8" />
    </g>
    <g fill="#a9afc5" opacity=".65">
      <circle cx="85" cy="34" r="2" />
      <circle cx="235" cy="113" r="2" />
      <circle cx="137" cy="136" r="1.5" />
      <circle cx="276" cy="95" r="1.5" />
    </g>
    <path d="M97 124v6 M94 127h6 M162 25v5 M159.5 27.5h5" fill="none" stroke="#9ba98d" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
